<template>
  <div class="detail-mobile" v-if='data'>
    <!-- <div class="header">
      <a href="http://ego.geekbang.org/"><img src="./assets/logo.png" alt="logo"></a>
      <div class="header-right">
        <span>加入 EGO，与全球杰出技术领<br />袖为伍，冲破局限，共同成长</span>
        <button type="button" name="button"><a href="http://ego.geekbang.org/together">加入我们</a></button>
      </div>
    </div> -->

    <div class="info-card">
      <div class="info">
        <img :src="data.photo" alt="avatar">
        <div class="desc">
          <h1>{{ data.name }}</h1>
          <p>职位： {{ data.position || '-' }}</p>
          <p>所属公司： {{ data.firm || '-' }}</p>
          <p>入会时间： {{ data.joinTime | parseDate }}</p>
        </div>
      </div>
    </div>

    <div class="nav-bar">
      <span v-show='data.introduce' :class='{"active": !nav}' class='left' @click='nav=0'>职业背景</span>
      <span v-show='data.memberInterview' :class='{"active": nav}' class='right' @click='nav=1'>人物访谈</span>
    </div>

    <div v-if='nav' class="interview">
      <div v-for='(item, i) in data.memberInterview' :key='i' class='item'>
        <h1>{{item.title}}</h1>
        <div v-html='item.contents'></div>
        <a :href='item.link' target='_blank' class='more'>了解更多>></a>
      </div>
    </div>
    <div v-else class="introduce" v-html='data.introduce'></div>
  </div>
</template>

<script>
export default {
  name: 'mobile',
  data () {
    return {
      nav: 0
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  filters: {
    parseDate (value) {
      let date = new Date(value * 1000)
      let month = date.getMonth() > 9 ? date.getMonth() : `0${date.getMonth()}`
      let day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
      return date.getFullYear() + '-' + month + '-' + day
    }
  }
}
</script>

<style lang="sass">
@import "./assets/css/variable"

.detail-mobile
  background-color: #f8f8f8
  .header
    display: flex
    height: 44px
    background: #fff
    padding: 10px 20px
    font-size: 10px
    align-items: center
    justify-content: space-between
    img
      height: 17.5px
      width: 69px
    .header-right
      display: flex
      align-items: center
      span
        text-align: right
        color: $lightgrayfont
        line-height: 1.2
      button
        font-size: 12px
        border-radius: 2px
        border: 1px solid $red
        background-color: #fff
        margin-left: 4px
        padding: 5px 10px
        transition: all 0.5s
        &:active, &:visited, &:hover, &:focus
          outline: none
          box-shadow: 0 0 2px $border
        a
          color: $red

  .info-card
    padding: 20px
    background: url('./assets/bg-mobile.jpg') no-repeat
    background-size: cover
    background-position: 50% 50%
    .info
      display: flex
      background: rgba(255, 255, 255, 0.7)
      padding: 25px 15px
      border-radius: 8px
      align-items: center
      img
        width: 88px
        height: 88px
        display: block
        border-radius: 50%
        margin-right: 16px
      .desc
        h1
          font-size: $little-font
          line-height: 28px
        p
          font-size: 12px
          color: #888888
          line-height: 1.5

  .nav-bar
    background: #fff
    height: 51px
    text-align: center
    font-size: $little-font
    span
      line-height: 51px
      padding: 16px 0px
      cursor: pointer
      &.left
        margin-right: 20px
      &.right
        margin-left: 20px
      &.active
        color: #D7B375
        border-bottom: 1px solid #D7B375

  .introduce
    padding: 15px 20px
    p
      color: #888888
      font-size: 12px
      line-height: 1.5
      margin-bottom: 12px
      text-align: justify
  .interview
    padding: 0 20px 20px
    .item
      margin-top: 15px
      border-bottom: 1px solid #e8e8e8
      &:last-child
        border-bottom: none
      h1
        font-size: 14px
        line-height: 18px
        margin-bottom: 8px
      div
        font-size: 12px
        line-height: 1.5
        margin-bottom: 12px
        text-align: justify
        color: #888888
      .more
        padding: 4px 0
        color: #D7B375
        display: inline-block
        font-size: 12px
        margin: 0 0 13px
        cursor: pointer
</style>
